import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useState } from 'react';

import { setHelpSearchString } from 'features/HomePage/services';
import { buildChatBotModal } from 'theSource/components/Chatbot/chatbot';
import destopChatBotIcon from 'assets/chatbot-desktop-icon.svg';

export const HelpSearch = () => {
  const { t } = useTranslation('pages.home');
  const dispatch = useDispatch();
  const [defaultInput, setDefaultInput] = useState('');

  const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'Enter') {
      return;
    }
    const inputElement = event.target as HTMLInputElement;
    dispatch(setHelpSearchString(inputElement.value));
    buildChatBotModal(inputElement.value);
    resetInput(inputElement);
  };

  const handleClick = (event: React.MouseEvent) => {
    const targetElement = event.target as HTMLElement;
    const searchIcon = document.getElementById(
      'help-search-input-icon'
    ) as HTMLButtonElement;

    // If the user clicked on the search icon then dispatch value
    if (targetElement === searchIcon) {
      //get input value
      const inputElement = document.getElementById(
        'help-search-input'
      ) as HTMLInputElement;
      dispatch(setHelpSearchString(inputElement.value));
      buildChatBotModal(inputElement.value);
      resetInput(inputElement);
    }
  };

  const resetInput = (inputElement: any) => {
    inputElement.value = '';
    setDefaultInput('');
  };

  const placeholderText =
    window.innerWidth < 744
      ? 'helpSearchPlaceholderMobile'
      : 'helpSearchPlaceholder';

  return (
    <div data-testid="help-search-input" className="d-flex">
      <div className="col px-0">
        <ps-text-field
          input-id="help-search-input"
          label={t('helpSearchPlaceholder')}
          hide-label
          type="search"
          placeholder={t(placeholderText)}
          value={defaultInput}
          onKeyUp={handleKeyUp}
          onClick={handleClick}
          extraClass="mt-4"
        />
      </div>
      <img id="chatbot-icon" src={destopChatBotIcon} alt="chatbot Icon" />
    </div>
  );
};
